import React from 'react';
import { Button, Modal } from 'antd';
import { Trash2 } from 'lucide-react';

import { useI18n } from '../../i18n';

export const DeleteConfirmModal = ({ onConfirm, onCancel, open }) => {
  const { t } = useI18n();
  return (
    <Modal centered width={420} open={open} onCancel={onCancel} footer={null} closable={false}>
      <div className='wm-confirm'>
        <div className='wm-confirm__icon'>
          <Trash2 size={18} strokeWidth={2} />
        </div>
        <div>
          <div className='wm-confirm__title'>{t('confirm.deleteTitle')}</div>
          <div className='wm-confirm__text'>{t('confirm.deleteText')}</div>
        </div>
      </div>
      <div className='wm-confirm__actions'>
        <Button onClick={onCancel}>{t('common.cancel')}</Button>
        <Button type='primary' danger onClick={onConfirm} autoFocus>
          {t('common.delete')}
        </Button>
      </div>
    </Modal>
  );
};
